import React, { useEffect, useState } from "react";
import Modal from "../../../../components/Modal";
import { Context } from "../../../../config/store";
import { objectsForEach } from "../../../../common/objectToArray";
import splitUnderscoreToCaptialise from "../../../../common/splitUnderscoreToCaptialise";
import LenderUgroService from "../../../../services/lender";
import { toast } from "react-toastify";

let modLength = 0;

const AdditionalInfoCTA = ({
  modalState,
  toggleModal,
  onChange,
  params,
  keyName,
  selectedLender,
  leadId,
  body,
}) => {
  const skeleton = params.find(({ id }) => id == keyName);
  const { title, type, cta_iteration, ...config } = skeleton?.cta_data;
  const [modalDataLength, setModalDataLength] = useState(0);

  const getCtaDataArray = (num) => {
    let data = [];
    Object.keys(skeleton?.cta_data).map((item) => {
      if (item !== "title" && item !== "type" && item !== "cta_iteration") {
        data.push({
          [item]: "",
        });
      }
    });
    modLength = data?.length;
    let newData = data.reduce((prev, curr) => ({ ...prev, ...curr }), {});
    const finalArray = Array.from(
      {
        length: num,
      },
      () => newData
    );
    return finalArray;
  };

  const { state } = React.useContext(Context);
  const [loading, setLoading] = React.useState(false);
  const [ctaData, setCtaData] = React.useState(
    getCtaDataArray(skeleton?.cta_data?.cta_iteration)
  );
  const [key, setKey] = React.useState(Math.random());
  const [errors, setErrors] = React.useState([]);
  const [assessmentType, setAssessmentType] = React.useState(
    body?.financial_details?.AssessmentType || ""
  );
  const [modalDataId, setModalDataId] = React.useState(skeleton?.id);

  const tempDate = new Date().toISOString().split("T")[0].split("-");
  const maxDate = `${tempDate[0]}-${tempDate[1]}`;

  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };

  useEffect(() => {
    setModalDataLength(modLength);
    body?.financial_details?.[modalDataId] && getAdditionalInformationAbbData();
  }, [modalDataId]);

  const getAdditionalInformationAbbData = async () => {
    let response = await LenderUgroService.getAdditionalInfoAbbData({
      type: state.userType,
      add_info_cta_id: body?.financial_details?.[modalDataId],
    });
    response?.data?.data?.addInfoCta?.res_json?.length > 0 &&
      setCtaData(response?.data?.data?.addInfoCta?.res_json);
  };

  const handleAbbModalChange = (index, name, value) => {
    let data = ctaData;
    const newData = data.map((p, i) =>
      i === index ? { ...p, [name]: value } : p
    );
    setCtaData(newData);
    setKey(Math.random());
  };

  const saveCTAData = async (e) => {
    e.preventDefault();
    let payloadData = {
      cta_config_data: {
        ...skeleton?.cta_data,
      },
      cta_data: ctaData,
    };
    let response = await LenderUgroService.saveAdditionalInfoAbbData({
      type: state.userType,
      leadId: leadId,
      cl_lender_id: selectedLender,
      payloadData,
      AssessmentType: assessmentType,
    });
    if (response.data?.status?.code == 1) {
      let cta_id = response?.data?.data?.add_info_cta_id;
      onChange({ target: { value: cta_id } });
      toast.success(
        response?.data?.messages?.success?.others[0] ||
        response?.data?.messages?.success?.form[0]
      );
      toggleModal();
    } else {
      setErrors(response?.data?.err_data?.cta_data);
    }
  };

  const onClose = async () => {
    body?.financial_details?.[modalDataId] &&
      (await getAdditionalInformationAbbData());
    setErrors([]);
    toggleModal();
  };

  return (
    <Modal
      state={modalState}
      closeModal={() => onClose()}
      removeBorderSpace={true}
      style={{
        width: 'fit-content',
        maxWidth: '90%'
      }}
    >
      <div className="card border-0">
        <div className="modal-header-container">
          <div className="modal-title">{skeleton.label}</div>
          <div className="closeModalView" onClick={() => onClose()}>
            <span className="closeModalIcon">x</span>
          </div>
        </div>
        <div className="px-4 pt-4 pb-3 modalData" style={{ maxHeight: "75vh" }}>
          <div className="row position-sticky">
            {objectsForEach(config).map((row, index) => (
              <div
                class={`col-md-${12 / modalDataLength}`}
                style={{ width: "150px", padding: "0px 5px" }}
              >
                <label
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: 'center',
                    textAlign: "center",
                    fontSize: "12x",
                  }}
                >
                  {row.label} {row.value == "1" && <tt>*</tt>}
                </label>
              </div>
            ))}
          </div>
          <form
            style={{
              maxHeight: "300px",
              overflowY: "scroll",
              overflowX: "clip",
              paddingLeft: "10px",
              paddingRight: "10px"
            }}
          >
            {ctaData?.map((val, index1) => {
              return (
                <div
                  class="row"
                  style={{
                    flexWrap: "nowrap",
                    overflowX: "auto",
                  }}
                >
                  {objectsForEach(config).map((row, index2) => (
                    <div
                      class={`col-md-${12 / modalDataLength}`}
                      style={{ width: "150px", padding: "0px 5px" }}
                    >
                      {row?.rule?.input_type == "dropdown" ? (
                        <>
                          <select
                            className="form-control"
                            name={row.id}
                            value={val?.[row.id]}
                            onChange={(e) =>
                              handleAbbModalChange(
                                index1,
                                row.id,
                                e.target.value
                              )
                            }
                          >
                            <option value="">Select</option>
                            {objectsForEach(row.rule.options, "STRING_VAL").map(
                              ({ value, id }) => (
                                <option value={value}>
                                  {splitUnderscoreToCaptialise(id)}
                                </option>
                              )
                            )}
                          </select>
                          {
                            <p
                              className="text-danger"
                              style={{
                                fontSize: "10px",
                                paddingTop: "0px",
                              }}
                            >
                              {errors[index1]?.[row.id]}
                            </p>
                          }
                        </>
                      ) : row?.rule?.input_type == "month" ? (
                        <>
                          <input
                            type="month"
                            name={row.id}
                            className="form-control"
                            value={val?.[row.id]}
                            onChange={(e) =>
                              handleAbbModalChange(
                                index1,
                                row.id,
                                e.target.value
                              )
                            }
                            max={maxDate}
                          />
                          {
                            <p
                              className="text-danger"
                              style={{
                                fontSize: "10px",
                                paddingTop: "0px",
                              }}
                            >
                              {errors[index1]?.[row.id]}
                            </p>
                          }
                        </>
                      ) : (
                        <>
                          <input
                            type={row?.rule?.input_type}
                            name={row.id}
                            className="form-control"
                            value={val?.[row.id]}
                            onChange={(e) =>
                              handleAbbModalChange(
                                index1,
                                row.id,
                                e.target.value
                              )
                            }
                          />
                          {
                            <p
                              className="text-danger"
                              style={{
                                fontSize: "10px",
                                paddingTop: "0px",
                              }}
                            >
                              {errors[index1]?.[row.id]}
                            </p>
                          }
                        </>
                      )}
                    </div>
                  ))}
                </div>
              );
            })}
          </form>
          <div className="position-sticky col-lg-12 col-md-12 col-sm-12 col-12 text-center">
            {(state.userType === "admin"
              ? checkHasPermission("save-additional-info")
              : true) && (
                <div style={{ marginTop: "10px" }}>
                  <button
                    className="btn btn-custom btn-custom-height m-auto"
                    disabled={loading}
                    onClick={saveCTAData}
                  >
                    {loading ? <div className="loader"></div> : "Save"}
                  </button>
                </div>
              )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AdditionalInfoCTA;
